import React from 'react'
import { useTranslation } from 'react-i18next'

export default React.memo(function ManagePage() {
  const { t } = useTranslation()

  return (
    <>
      <h1>{t('manage')}</h1>
    </>
  )
})

export function ManagePageBreadcrumb() {
  const { t } = useTranslation()
  return <span>{t('manage')}</span>
}
